/**
 * Cross-origin, the `download` attribute is ignored and the served
 * Content-Disposition decides the filename.
 */
export const downloadFromUrl = (url: string, filename: string): void => {
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);

  downloadFromUrl(url, filename);
  URL.revokeObjectURL(url);
};
